import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CreateBookingService } from '../../create-booking.service';
import { FormArray, FormGroup } from '@angular/forms';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import {AddRiderService} from 'src/app/shared/services/add-rider.service'
import { MatDialog} from '@angular/material/dialog';
import { AddRiderComponent } from '../add-rider/add-rider.component';


@Component({
  selector: 'app-new-rider-table',
  templateUrl: './new-rider-table.component.html',
  styleUrls: ['./new-rider-table.component.scss']
})
export class NewRiderTableComponent extends BaseFormGroup implements OnInit, OnDestroy {

  @Input() config: any;
  @Input() whatsappComm: any;
  @Input() referenceBooking: any;
  @Input() formArray: any;
  @Input() miscelleneousConfig: any;
  @Input() tripFormDetails: FormGroup;
  @Input() enableAlternateMobileNumber: boolean;
  @Input() riderTypeMapping: any;
  

  private destroy$ = new Subject();
  public selectedPayer;
  whatsappCommunication:boolean=false;
  addRiderConfig:any
  private riderAddress = [];
  private bookingEditConfigObj: any;
  engagementConfig: any;
  public payeeOptions: any[] = [];
  riderLimitReached:boolean=false;
  riderLimit:any;
  public riderStateArray: any[] = [];
  phoneNumberInEtsMandatory = {};
  etsValuesMandatory = false;
  private watchers: any[] = [];
  riderGuidList=[];
  isSelfRider: boolean;


  constructor(
    private createBookingService: CreateBookingService,
    private commonBookingService: CommonBookingService,
    private commonService: CommonService,
    public addRiderService : AddRiderService,
    private changeDetectorRef:ChangeDetectorRef,
    public dialog: MatDialog
  ) { super()}
 

  @Input() set requester(requester: any) {
    if (requester) {
      this.addRiderService.updateRequester({
        riderType:  this.addRiderService.getSelfKey(),
        riderTypeId:'Self',
        name: requester.name,
        emplId: requester.emplId,
        gender: requester.gender,
        department: requester.department,
        email: requester.email,
        mobile: requester.mobile,
        phoneCode:requester.phoneCode,
        emplGuid:requester.emplGuid,
        payerGuid: this.selectedPayer,
        businessUnit: requester.businessUnit
})}
}

  @Input()
  set bookingEditConfig(bookingEditConfig: any) {
    if (bookingEditConfig) {
      this.bookingEditConfigObj = bookingEditConfig;
      // this.recheckButtonVisibility();
    }
  }


  ngOnInit(): void {
    //watsapp feature visibility in edit flow
    if (this.referenceBooking?.whatsappCommunication) { this.whatsappCommunication = this.referenceBooking?.whatsappCommunication; }

    this.addRiderService.setAlternateNumberVisibility(this.enableAlternateMobileNumber)

    // add rider button config controlled
    this.config.elementConfigList.forEach(ele => {
      if (ele.elementKey == "AddRiderRow"){
        this.addRiderConfig = {
          visibility: ele.config.visibility.visible,
          displayName: ele.config.displayName,
          key: ele.elementKey
        };
      }
    });

    //get address for self
    this.commonBookingService.savedAddressesForRiders
      .pipe(takeUntil(this.destroy$))
      .subscribe((address) => {
        if (address) {
          this.riderAddress = address;
        }
      });
      this.addRiderService.setRiderTypeMapping(this.riderTypeMapping)

        this.addRiderService.setConfig(this.config)
        this.addRiderService.setMiscConfig(this.miscelleneousConfig)
        
        this.addRiderService.setFormArray(this.formArray)
        this.formArray=this.addRiderService.getFormArray()

       this.riderLimit= this.addRiderService.getRiderLimit()
        this.addRiderService.getConfig()
        this.addRiderService.getCostCenters();
        this.addRiderService.getDepartments();
}

updateRequester(requester: any) {
  this.addRiderService.updateTableWithRider(requester);
}

onWhatsappCheck(event){
    this.createBookingService.getWhatsappNotify.next(event.value);
}

addPassenger(rideform?,editBooking?:boolean){
 
  this.dialog.open(AddRiderComponent,{
    data: {
      editRideform: editBooking ? rideform : {},
      editBooking: editBooking ? true : false
    }
  });
}

onDeleteClick(index: number) {
  this.riderStateArray.splice(index, 1);
  const removedRider = this.formArray.at(index).getRawValue();
  const riderAddr = this.riderAddress.filter((address) => address.employeeId !== removedRider.emplId);
  this.commonBookingService.updateHomeAddressesOfRiders(riderAddr);
  if (removedRider.riderTypeId === 'Self') {
    this.commonService.setValue('1');
    this.isSelfRider = false;
    this.changeDetectorRef.detectChanges();
  }
  this.formArray.removeAt(index);
  if (this.etsValuesMandatory) {
    if (this.formArray.controls.length) {
      for (let i = 0; i < this.formArray.controls.length; i++) {
        this.addRiderService.checkMobileNumberInEts(i);
      }
    } else {
      this.phoneNumberInEtsMandatory[0] = false;
    }

  }
  this.removeRiderFromTrips(removedRider);
  if (this.formArray.length) {
    this.selectedPayer = this.formArray.controls[0].get('emplGuid').value;
    this.addRiderService.constructPayeeForm(this.formArray);
  } else {
    this.commonBookingService.getSelectedPayer(null);
  }
  if (this.commonService.workflowConfig.riderLimit) {
  }
}

removeRiderFromTrips(removedRider: any) {
  const removedRiderId = removedRider.travellerId;
  const newRiders = this.createBookingService.newRiders;

  // If the removed rider is in the newRiders array, remove it and return
  const newRiderIndex = newRiders.indexOf(removedRiderId);
  if (newRiderIndex > -1) {
    newRiders.splice(newRiderIndex, 1);
    return;
  }

  // If the removed rider is not in the newRiders array, search for it in tripFormDetails
  const dateFormArray = this.tripFormDetails.get('dateWise') as FormArray;
  if (!(dateFormArray instanceof FormArray && dateFormArray.length)) return;

  dateFormArray.controls.forEach(dateForm => {
    if (!(dateForm instanceof FormGroup)) return;

    const cabs = dateForm.get('cabs') as FormArray;
    if (!(cabs instanceof FormArray && cabs.length)) return;

    cabs.controls.forEach(cab => {
      const stops = cab.get('stops') as FormArray;
      if (!(stops instanceof FormArray)) return;

      stops.controls.forEach(stop => {
        const riders = stop.get('riders') as FormArray;
        if (!(riders instanceof FormArray && riders.length)) return;

        const riderIndex = riders.controls.findIndex(rider => rider instanceof FormGroup && rider.get('name').value === removedRiderId);
        if (riderIndex > -1) {
          riders.removeAt(riderIndex);
          return;
        }
      });
    });
  });
}

ngOnDestroy() {
  this.formArray.controls.forEach(control => {
    let emplGuid=''
    if(control.get('emplGuid'))
        emplGuid = control.get('emplGuid').value;
    this.riderGuidList.push(emplGuid);
  });

  this.createBookingService.riderGuid.next(this.riderGuidList);

  this.watchers.forEach((watcher) => {
    watcher.unsubscribe();
  });
  this.destroy$.next();
  this.destroy$.complete();
}

}
